<div class="outer-container">
   <span style="text-align: right; color: red; font-size: 18px; font-weight: 600; margin-right: 25px"><i>* Below is only a mockup image</i></span>
   <img src="assets/gtk/directorScreenshot.jpg" />
</div>
